import { render, staticRenderFns } from "./DebtTypeSummary.vue?vue&type=template&id=1a1415ea"
import script from "./DebtTypeSummary.vue?vue&type=script&lang=js"
export * from "./DebtTypeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports